var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useClientsStatusAPI } from '../clients/selectors';
import { OrgConfigStepPanel } from '../common/stepContainer';
import { OrgConfigStep } from '../constants';
import { OrgConfigWizardContext, useOrgConfigDirtyRegister } from '../context';
import { useFinancialsStatusAPI } from '../financials/selectors';
import { useLocationHoursBatchAPI } from '../hours/selectors';
import { useSeatsStatusAPI } from '../seats/selectors';
import { useLocationsAPI, useShrinkageStatusAPI } from '../selectors';
import { useStaffSettingsStatusAPI } from '../staffSettings/selectors';
import { useStaffingStatusAPI } from '../staffing/selectors';
import { ReviewSectionHeader } from './ReviewSectionHeader';
import { ReviewTitleBar } from './ReviewTitleBar';
import { ReviewFinancialsSection } from './sections/ReviewFinancialsSection';
import { ReviewHoursSection } from './sections/ReviewHoursSection';
import { ReviewLocationSection } from './sections/ReviewLocationSection';
import { ReviewSeatsSection } from './sections/ReviewSeatsSection';
import { ReviewShrinkageSection } from './sections/ReviewShrinkageSection';
import { ReviewStaffSettingsSection } from './sections/ReviewStaffSettingsSection';
import { useReviewSectionRegistry } from './useReviewSectionRegistry';
export var ReviewStep = function () {
  var _a, _b, _c;
  var _d = useContext(OrgConfigWizardContext),
    configVersionId = _d.configVersionId,
    goToStep = _d.goToStep,
    setBeforeNext = _d.setBeforeNext,
    selectedLocationId = _d.selectedLocationId,
    setSelectedLocationId = _d.setSelectedLocationId,
    isViewOnly = _d.isViewOnly;
  var t = useTranslation('orgConfig').t;
  var tReview = useTranslation('orgConfig', {
    keyPrefix: 'orgConfigWizard.reviewStep'
  }).t;
  var _e = useLocationsAPI(configVersionId),
    locationsData = _e[0],
    fetchLocations = _e[1];
  var locations = useMemo(function () {
    var _a, _b;
    return (_b = (_a = locationsData.data) === null || _a === void 0 ? void 0 : _a.locations) !== null && _b !== void 0 ? _b : [];
  }, [locationsData.data]);
  var _f = useLocationHoursBatchAPI(configVersionId),
    hoursBatchData = _f[0],
    fetchHoursBatch = _f[1];
  var hoursBatch = useMemo(function () {
    var _a;
    return (_a = hoursBatchData.data) !== null && _a !== void 0 ? _a : [];
  }, [hoursBatchData.data]);
  var _g = useStaffSettingsStatusAPI(configVersionId),
    staffSettingsStatusData = _g[0],
    fetchStaffSettingsStatus = _g[1];
  var _h = useShrinkageStatusAPI(configVersionId),
    shrinkageStatusData = _h[0],
    fetchShrinkageStatus = _h[1];
  var _j = useStaffingStatusAPI(configVersionId),
    staffingStatusData = _j[0],
    fetchStaffingStatus = _j[1];
  var _k = useFinancialsStatusAPI(configVersionId),
    financialsStatusData = _k[0],
    fetchFinancialsStatus = _k[1];
  var _l = useClientsStatusAPI(configVersionId),
    clientsStatusData = _l[0],
    fetchClientsStatus = _l[1];
  var _m = useSeatsStatusAPI(configVersionId),
    seatsStatusData = _m[0],
    fetchSeatsStatus = _m[1];
  useEffect(function () {
    if (configVersionId) fetchLocations();
  }, [configVersionId, fetchLocations]);
  useEffect(function () {
    if (configVersionId) fetchHoursBatch();
  }, [configVersionId, fetchHoursBatch]);
  useEffect(function () {
    if (configVersionId) fetchStaffSettingsStatus();
  }, [configVersionId, fetchStaffSettingsStatus]);
  useEffect(function () {
    if (configVersionId) fetchShrinkageStatus();
  }, [configVersionId, fetchShrinkageStatus]);
  useEffect(function () {
    if (configVersionId) fetchStaffingStatus();
  }, [configVersionId, fetchStaffingStatus]);
  useEffect(function () {
    if (configVersionId) fetchFinancialsStatus();
  }, [configVersionId, fetchFinancialsStatus]);
  useEffect(function () {
    if (configVersionId) fetchClientsStatus();
  }, [configVersionId, fetchClientsStatus]);
  useEffect(function () {
    if (configVersionId) fetchSeatsStatus();
  }, [configVersionId, fetchSeatsStatus]);
  var selectedLocation = useMemo(function () {
    var _a;
    return (_a = locations.find(function (l) {
      return l.id === selectedLocationId;
    })) !== null && _a !== void 0 ? _a : null;
  }, [locations, selectedLocationId]);
  var registry = useReviewSectionRegistry();
  var _o = useState({}),
    staffSettingsFormMap = _o[0],
    setStaffSettingsFormMap = _o[1];
  var handleStaffSettingsFormChange = useCallback(function (locationId, form) {
    setStaffSettingsFormMap(function (prev) {
      var _a;
      return __assign(__assign({}, prev), (_a = {}, _a[locationId] = form, _a));
    });
  }, []);
  var onSelectLocation = useCallback(function (nextId) {
    return __awaiter(void 0, void 0, void 0, function () {
      var canChangeLocation;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            registry.cancelAll();
            return [4 /*yield*/, registry.flushAll()];
          case 1:
            canChangeLocation = _a.sent();
            if (canChangeLocation) setSelectedLocationId(nextId);
            return [2 /*return*/];
        }
      });
    });
  }, [registry, setSelectedLocationId]);
  useEffect(function () {
    var beforeNextFn = function () {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          registry.cancelAll();
          return [2 /*return*/, registry.flushAll()];
        });
      });
    };
    setBeforeNext(beforeNextFn);
    return function () {
      return setBeforeNext(null);
    };
  }, [setBeforeNext, registry]);
  var hasMadeChangesRef = useRef(false);
  var isCurrentlyDirty = (_b = (_a = registry.isDirty) === null || _a === void 0 ? void 0 : _a.call(registry)) !== null && _b !== void 0 ? _b : false;
  useEffect(function () {
    if (isCurrentlyDirty) {
      hasMadeChangesRef.current = true;
    }
  }, [isCurrentlyDirty]);
  var checkIsDirty = useCallback(function () {
    var _a, _b;
    return hasMadeChangesRef.current || ((_b = (_a = registry.isDirty) === null || _a === void 0 ? void 0 : _a.call(registry)) !== null && _b !== void 0 ? _b : false);
  }, [registry]);
  useOrgConfigDirtyRegister(checkIsDirty);
  var navigateToStep = useCallback(function (stepIndex) {
    return __awaiter(void 0, void 0, void 0, function () {
      var ok;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            registry.cancelAll();
            return [4 /*yield*/, registry.flushAll()];
          case 1:
            ok = _a.sent();
            if (ok) goToStep(stepIndex);
            return [2 /*return*/];
        }
      });
    });
  }, [registry, goToStep]);
  var handleLocationSaved = useCallback(function () {
    fetchLocations();
  }, [fetchLocations]);
  var missingData = useMemo(function () {
    var _a, _b, _c, _d, _e;
    if (!locations.length) return [];
    var entries = [];
    // Hours
    var hoursMissing = locations.filter(function (loc) {
      var hasTimezone = !!loc.timezone && loc.timezone !== 'UTC';
      var batch = hoursBatch.find(function (h) {
        return h.locationId === loc.id;
      });
      var hasHours = batch === null || batch === void 0 ? void 0 : batch.hours.some(function (h) {
        return h.isAvailable && h.startTime && h.endTime;
      });
      return !hasTimezone || !hasHours;
    }).map(function (loc) {
      return loc.locationName;
    });
    if (hoursMissing.length > 0) {
      entries.push({
        step: OrgConfigStep.Hours,
        label: tReview('stepLabel', {
          number: OrgConfigStep.Hours + 1,
          name: t('orgConfigWizard.hours')
        }),
        locationNames: hoursMissing
      });
    }
    // Staff Settings
    var staffSettingsStatus = (_a = staffSettingsStatusData.data) !== null && _a !== void 0 ? _a : [];
    var staffSettingsMissing = locations.filter(function (loc) {
      var _a;
      return !((_a = staffSettingsStatus.find(function (s) {
        return s.locationId === loc.id;
      })) === null || _a === void 0 ? void 0 : _a.hasConfig);
    }).map(function (loc) {
      return loc.locationName;
    });
    if (staffSettingsMissing.length > 0) {
      entries.push({
        step: OrgConfigStep.StaffSettings,
        label: tReview('stepLabel', {
          number: OrgConfigStep.StaffSettings + 1,
          name: t('orgConfigWizard.staffSettings')
        }),
        locationNames: staffSettingsMissing
      });
    }
    // Shrinkage
    var shrinkageStatus = (_b = shrinkageStatusData.data) !== null && _b !== void 0 ? _b : [];
    var shrinkageMissing = locations.filter(function (loc) {
      var _a;
      return !((_a = shrinkageStatus.find(function (s) {
        return s.locationId === loc.id;
      })) === null || _a === void 0 ? void 0 : _a.hasConfig);
    }).map(function (loc) {
      return loc.locationName;
    });
    if (shrinkageMissing.length > 0) {
      entries.push({
        step: OrgConfigStep.Shrinkage,
        label: tReview('stepLabel', {
          number: OrgConfigStep.Shrinkage + 1,
          name: t('orgConfigWizard.shrinkage')
        }),
        locationNames: shrinkageMissing
      });
    }
    // Support Roles
    var staffingStatus = (_c = staffingStatusData.data) !== null && _c !== void 0 ? _c : [];
    var supportRolesMissing = locations.filter(function (loc) {
      var _a;
      return !((_a = staffingStatus.find(function (s) {
        return s.locationId === loc.id;
      })) === null || _a === void 0 ? void 0 : _a.hasConfig);
    }).map(function (loc) {
      return loc.locationName;
    });
    if (supportRolesMissing.length > 0) {
      entries.push({
        step: OrgConfigStep.SupportRoles,
        label: tReview('stepLabel', {
          number: OrgConfigStep.SupportRoles + 1,
          name: t('orgConfigWizard.supportRoles')
        }),
        locationNames: supportRolesMissing
      });
    }
    // Financials
    var financialsStatus = (_d = financialsStatusData.data) !== null && _d !== void 0 ? _d : [];
    var financialsMissing = locations.filter(function (loc) {
      var _a;
      return !((_a = financialsStatus.find(function (s) {
        return s.locationId === loc.id;
      })) === null || _a === void 0 ? void 0 : _a.hasConfig);
    }).map(function (loc) {
      return loc.locationName;
    });
    if (financialsMissing.length > 0) {
      entries.push({
        step: OrgConfigStep.Financials,
        label: tReview('stepLabel', {
          number: OrgConfigStep.Financials + 1,
          name: t('orgConfigWizard.financials')
        }),
        locationNames: financialsMissing
      });
    }
    // Clients/LOBs org-level, not per-location
    if (clientsStatusData.data && !clientsStatusData.data.hasConfig) {
      entries.push({
        step: OrgConfigStep.ClientsLobs,
        label: tReview('stepLabel', {
          number: OrgConfigStep.ClientsLobs + 1,
          name: t('orgConfigWizard.clientsLobs')
        }),
        locationNames: []
      });
    }
    // Seats
    var seatsStatus = (_e = seatsStatusData.data) !== null && _e !== void 0 ? _e : [];
    var seatsMissing = locations.filter(function (loc) {
      var _a;
      return !((_a = seatsStatus.find(function (s) {
        return s.locationId === loc.id;
      })) === null || _a === void 0 ? void 0 : _a.hasConfig);
    }).map(function (loc) {
      return loc.locationName;
    });
    if (seatsMissing.length > 0) {
      entries.push({
        step: OrgConfigStep.Seats,
        label: tReview('stepLabel', {
          number: OrgConfigStep.Seats + 1,
          name: t('orgConfigWizard.seats')
        }),
        locationNames: seatsMissing
      });
    }
    return entries;
  }, [locations, hoursBatch, staffSettingsStatusData.data, shrinkageStatusData.data, staffingStatusData.data, financialsStatusData.data, clientsStatusData.data, seatsStatusData.data, t, tReview]);
  return _jsxs(OrgConfigStepPanel, {
    children: [_jsx(ReviewTitleBar, {
      locations: locations,
      selectedLocationId: selectedLocationId,
      onLocationChange: onSelectLocation,
      missingData: missingData,
      onNavigateToStep: function (step) {
        return void navigateToStep(step);
      },
      isViewOnly: isViewOnly
    }), _jsxs(Stack, __assign({
      spacing: 10,
      sx: {
        mt: 4
      }
    }, {
      children: [selectedLocation && _jsxs(Stack, __assign({
        spacing: 2
      }, {
        children: [_jsx(ReviewSectionHeader, {
          label: selectedLocation.locationName,
          onNavigate: function () {
            return void navigateToStep(OrgConfigStep.Locations);
          },
          subtitle: tReview('goToLocation', {
            step: OrgConfigStep.Locations + 1
          }),
          viewOnly: isViewOnly
        }), _jsx(ReviewLocationSection, {
          location: selectedLocation,
          registry: registry,
          onSaved: handleLocationSaved
        })]
      })), selectedLocation && _jsxs(Stack, __assign({
        spacing: 2
      }, {
        children: [_jsx(ReviewSectionHeader, {
          label: tReview('siteHoursOfOperation'),
          onNavigate: function () {
            return void navigateToStep(OrgConfigStep.Hours);
          },
          subtitle: tReview('goToHours', {
            step: OrgConfigStep.Hours + 1
          }),
          viewOnly: isViewOnly
        }), _jsx(ReviewHoursSection, {
          locationId: selectedLocation.id,
          registry: registry
        })]
      })), selectedLocation && _jsxs(Stack, __assign({
        spacing: 2
      }, {
        children: [_jsx(ReviewSectionHeader, {
          label: t('orgConfigWizard.staffSettings'),
          onNavigate: function () {
            return void navigateToStep(OrgConfigStep.StaffSettings);
          },
          subtitle: tReview('goToStaffSettings', {
            step: OrgConfigStep.StaffSettings + 1
          }),
          viewOnly: isViewOnly
        }), _jsx(ReviewStaffSettingsSection, {
          locationId: selectedLocation.id,
          registry: registry,
          onFormChange: handleStaffSettingsFormChange
        })]
      })), selectedLocation && _jsxs(Stack, __assign({
        spacing: 2
      }, {
        children: [_jsx(ReviewSectionHeader, {
          label: tReview('shrinkage'),
          onNavigate: function () {
            return void navigateToStep(OrgConfigStep.Shrinkage);
          },
          subtitle: tReview('goToShrinkage', {
            step: OrgConfigStep.Shrinkage + 1
          }),
          viewOnly: isViewOnly
        }), _jsx(ReviewShrinkageSection, {
          locationId: selectedLocation.id,
          registry: registry,
          staffSettingsForm: (_c = staffSettingsFormMap[selectedLocation.id]) !== null && _c !== void 0 ? _c : null
        })]
      })), selectedLocation && _jsxs(Stack, __assign({
        spacing: 2
      }, {
        children: [_jsx(ReviewSectionHeader, {
          label: tReview('supportStaffFinancials'),
          onNavigate: function () {
            return void navigateToStep(OrgConfigStep.SupportRoles);
          },
          subtitle: tReview('goToSupportRoles', {
            step: OrgConfigStep.SupportRoles + 1
          }),
          viewOnly: isViewOnly
        }), _jsx(ReviewFinancialsSection, {
          locationId: selectedLocation.id,
          registry: registry
        })]
      })), selectedLocation && configVersionId && _jsxs(Stack, __assign({
        spacing: 2
      }, {
        children: [_jsx(ReviewSectionHeader, {
          label: tReview('seatInventory'),
          onNavigate: function () {
            return void navigateToStep(OrgConfigStep.Seats);
          },
          subtitle: tReview('goToSeats', {
            step: OrgConfigStep.Seats + 1
          }),
          viewOnly: isViewOnly
        }), _jsx(ReviewSeatsSection, {
          location: selectedLocation,
          registry: registry,
          configVersionId: configVersionId
        })]
      }))]
    }))]
  });
};